import { darken, lighten } from '@mui/material';
import { additionalColors } from './additional-colors';
import createPalette from '@mui/material/styles/createPalette';
import { autoscan_colors, baxi_colors, car_dark, car_light, heat_dark, heat_light, security, valtec, zont_colors, } from './colors/brands';
import { action_colors, background_colors, common_colors, error_colors, info_colors, success_colors, text_colors, warning_colors, } from './colors/commons';
import { mapRecord } from 'console/shared/utils/entries';
import { UserCustomColors } from './types';
const getPaperBackgroundColor = (dark, color) => dark ? lighten(color, 0.05) : lighten(color, 0.7);
const getContrastText = (dark) => (dark ? '#f0f0f0' : '#f5f5f5');
const convertUserThemeToMUI = (dark, user_theme, default_palette) => {
    const theme = mapRecord(default_palette, (field, color) => {
        const theme_field = dark ? 'dark' : 'light';
        const custom_color = user_theme?.[theme_field]?.[field];
        if (custom_color) {
            if (common_colors.includes(field)) {
                return [
                    field,
                    {
                        ...color,
                        light: lighten(custom_color, 0.3),
                        main: custom_color,
                        dark: darken(custom_color, 0.2),
                        contrastText: getContrastText(dark),
                    },
                ];
            }
            if (field === UserCustomColors.background) {
                return [
                    field,
                    {
                        ...color,
                        default: custom_color,
                        paper: getPaperBackgroundColor(dark, custom_color),
                    },
                ];
            }
        }
        return [field, color];
    });
    return theme;
};
const getBrandColors = (dark, user_theme) => {
    const zont = convertUserThemeToMUI(dark, user_theme, zont_colors(dark));
    const autoscan = autoscan_colors(dark);
    const baxi = baxi_colors(dark);
    return {
        autoscan,
        baxi,
        zont,
        valtec,
        heat_light,
        heat_dark,
        car_light,
        car_dark,
        security,
    };
};
export function baseThemeColor(dark, brand_code, user_theme = {}) {
    const { primary, secondary, error = error_colors(dark), warning = warning_colors(dark), success = success_colors(dark), info = info_colors(dark), background = background_colors(dark), } = getBrandColors(dark, user_theme)[brand_code] ??
        getBrandColors(dark, user_theme)['zont'];
    return createPalette({
        mode: dark ? 'dark' : 'light',
        primary,
        secondary,
        background,
        text: text_colors(dark),
        error,
        warning: warning,
        success: success,
        info,
        action: action_colors(dark),
        ...additionalColors.palette,
    });
}
